export default {
  xAxes: [
    {
      gridLines: {
        color: 'rgba(0, 0, 0, 0)',
      },
    },
  ],
  yAxes: [
    {
      ticks: {
        beginAtZero: true,
      },
      gridLines: {
        color: 'rgba(230,230,230, 1)',
      },
    },
  ],
}
